<div class="hcm-dialog">
  <div class="d-flex justify-content-between align-items-center hcm-label bottom border">
    <div class="order-1 hcm-dialog-title pt-3 px-4 py-3 align-items-center"><img src="../../../../../assets/img/alert-icon.png"
        *ngIf="data.showAlert" class="bi bi-house-door" alt="HCM Alert">
      {{ data.title }}</div>
  </div>
  <div class="hcm-dialog-content">
  <mat-accordion>
    <mat-expansion-panel (opened)="panelOpenState1.set(true)" (closed)="panelOpenState1.set(false)" [expanded]="true">
      <mat-expansion-panel-header class="mt-1">
        <mat-panel-title> {{'dialog.titles.newRunoutInformation' | translate}} </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="row px-2 pt-2">
        <div class="col-6 col-md-4">
        <div class="hcm-label mb-1">{{ 'vehicleInfo.labels.supplier' | translate }}<br>
        <span class="hcm-value">{{data.runOutData?.supplierCode}}</span>
        </div>
        </div>
        <div class="col-6 col-md-4">
        <div class="hcm-label mb-1">{{ 'vehicleInfo.labels.dock' | translate }}<br>
        <span class="hcm-value">{{data.runOutData?.dockCode }}</span>
        </div>
        </div>
        <div class="col-6 col-md-4">
        <div class="hcm-label mb-1">{{ 'vehicleInfo.labels.kanban' | translate }}<br>
        <span class="hcm-value">{{data.runOutData?.kanbanCode }}</span>
        </div>
        </div>
         
          <div class="col-6 col-md-4">
        <div class="hcm-label mb-1">{{ 'vehicleInfo.labels.partNumber' | translate }}<br>
        <span class="hcm-value">{{data.runOutData?.partNumber }}</span>
        </div>
        </div>
        <div class="col-6 col-md-4">
        <div class="hcm-label mb-1">{{ 'vehicleInfo.labels.linesideAddress' | translate }}<br>
        <span class="hcm-value">{{data.runOutData?.linesideAddress }}</span>
        </div>
        </div>
        <div class="col-6 col-md-4">
        <div class="hcm-label mb-1">{{ 'vehicleInfo.labels.currentVehicleSeq' | translate }}<br>
        <span class="hcm-value">{{data.runOutData?.currentVehicleSeq}}</span>
        </div>
        </div>
        </div>
      
      <div class="hot-call-box-border mx-0 pt-2">
        <div class="row px-2 ">
          <div class="col-md-4">
            <div class="hcm-label mb-1">{{ 'vehicleInfo.labels.piecesRemaining' | translate }}<br>
              <span class="hcm-value">{{data.runOutData?.piecesRemaining }}</span>
            </div>
          </div>
          <div class="col-md-4">
            <div class="hcm-label mb-1">{{ 'vehicleInfo.labels.vehiclesToEmpty' | translate }}<br>
              <span class="hcm-value">{{data.runOutData?.vehiclesToEmpty }}</span>
            </div>
          </div>
          <div class="col-md-4">
            <div class="hcm-label mb-1">{{ 'vehicleInfo.labels.firstVehicleSeq' | translate }}<br>
              <span class="hcm-value">{{data.runOutData?.firstMissedPartSeqNo }}</span>
            </div>
          </div>
        </div>
        <div class="row px-2">  
          <div class="col-md-4">
            <div class="hcm-label mb-1">{{ 'vehicleInfo.labels.firstVehicleBody' | translate }}<br>
              <span class="hcm-value">{{data.runOutData?.firstMissedPartBodyNo }}</span>
            </div>
          </div>
          <div class="col-md-4">
            <div class="hcm-label p-0 mb-1">{{ 'vehicleInfo.labels.trackingPoint' | translate }}<br>
              <span class="hcm-value">{{data.runOutData?.tpCount }}</span>
            </div>
          </div>
        </div>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
  <mat-accordion>
    <mat-expansion-panel (opened)="panelOpenState2.set(true)" (closed)="panelOpenState2.set(false)">
      <mat-expansion-panel-header>
        <mat-panel-title>{{'dialog.titles.oldRunoutInformation' | translate}} </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="row px-2 pt-2">
        <div class="col-6 col-md-4">
        <div class="hcm-label mb-1">{{ 'vehicleInfo.labels.supplier' | translate }}<br>
          <span
          class="hcm-value">{{data.oldRunOutData?.supplierCode}}</span>
        </div>
        </div>
        <div class="col-6 col-md-4">
        <div class="hcm-label mb-1">{{ 'vehicleInfo.labels.dock' | translate }}<br>
          <span
          class="hcm-value">{{data.oldRunOutData?.dockCode}}</span>
        </div>
        </div>
        <div class="col-6 col-md-4">
        <div class="hcm-label mb-1">{{ 'vehicleInfo.labels.kanban' | translate }}<br>
          <span class="hcm-value">{{data.oldRunOutData?.kanbanCode}}</span>
        </div>
        </div>
         
          <div class="col-6 col-md-4">
        <div class="hcm-label mb-1">{{ 'vehicleInfo.labels.partNumber' | translate }}<br>
          <span
          class="hcm-value">{{data.oldRunOutData?.partNumber}}</span>
        </div>
        </div>
        <div class="col-6 col-md-4">
        <div class="hcm-label mb-1">{{ 'vehicleInfo.labels.linesideAddress' | translate }}<br>
          <span
          class="hcm-value">{{data.oldRunOutData?.linesideAddress}}</span>
        </div>
        </div>
        <div class="col-6 col-md-4">
        <div class="hcm-label mb-1">{{ 'vehicleInfo.labels.currentVehicleSeq' | translate }}<br>
          <span
          class="hcm-value">{{data.oldRunOutData?.currentVehicleSeq}}</span>
        </div>
        </div>
        </div>
      
      <div class="hot-call-box-border mx-0 pt-2">
        <div class="row px-2">
          <div class="col-md-4">
            <div class="hcm-label mb-1">{{ 'vehicleInfo.labels.piecesRemaining' | translate }}<br>
              <span
              class="hcm-value">{{data.oldRunOutData?.piecesRemaining}}</span>
            </div>
          </div>
          <div class="col-md-4">
            <div class="hcm-label mb-1">{{ 'vehicleInfo.labels.vehiclesToEmpty' | translate }}<br>
              <span
              class="hcm-value">{{data.oldRunOutData?.vehiclesToEmpty}}</span>
            </div>
          </div>
          <div class="col-md-4">
            <div class="hcm-label mb-1">{{ 'vehicleInfo.labels.firstVehicleSeq' | translate }}<br>
              <span
                    class="hcm-value">{{data.oldRunOutData?.firstMissedPartSeqNo}}</span>
            </div>
          </div>
        </div>
        <div class="row px-2">  
          <div class="col-md-4">
            <div class="hcm-label mb-1">{{ 'vehicleInfo.labels.firstVehicleBody' | translate }}<br>
              <span
                    class="hcm-value">{{data.oldRunOutData?.firstMissedPartBodyNo}}</span>
            </div>
          </div>
          <div class="col-md-4">
            <div class="hcm-label p-0 mb-1">{{ 'vehicleInfo.labels.trackingPoint' | translate }}<br>
              <span
              class="hcm-value">{{data.oldRunOutData?.tpCount}}</span>
            </div>
          </div>
        </div>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
  <div class="d-flex">
    <p class="hcm-value px-3 pt-4 mb-1">{{ data.message }}</p>
  </div>
  <div class="d-flex justify-content-end pt-4 px-4 py-4 gap-3">
    <button class="hcm-blue-btn text-decoration-none" (click)="onCancel()">
      {{ 'dialog.buttons.DISCARD' | translate }}
    </button>
    <button class="hcm-black-btn px-3" (click)="updateRunOut()">
      {{ 'dialog.buttons.UPDATE' | translate }}
    </button>
  </div>
</div>

  <div class="hcm-dialog-close">
    <img src="../../../../../assets/img/close.svg" class="smaller-icon" alt="close icon" (click)="onCancel()">
  </div>
</div>